// src/hooks/useDashboardSettings.js
// ダッシュボードの並べ方（人ごと）【2026-09-18】
//
//   'priority' = 標準。重要度の高いものから順に置く。
//                0層 いま動いているもの / 1層 要対応 / 2層 数字 / 3層 一覧。
//   'classic'  = 元の表示。2026-09-17 までの並び（統計4枚 → クイックアクション → 表）。
//
//   保存は useUiSetting と同じ仕組み（/api/ui-settings、v42）。
//   サーバーが使えないときはブラウザにだけ覚えるので、切り替え自体はいつでもできる。
import useUiSetting from './useUiSetting';

export const DASHBOARD_DEFAULTS = { layout: 'priority' };

/** 選べる並べ方。切り替えはアカウント設定（/profile）の「画面の表示」にある。 */
export const DASHBOARD_LAYOUTS = [
  { key: 'priority', label: '標準（重要度順）',
    desc: '対応が要るものを上に出し、一覧は折りたたむ' },
  { key: 'classic',  label: '元の表示',
    desc: '統計4枚 → よく使う画面 → 表、を上から順に並べる' },
];

export function normalizeDashboardSettings(v) {
  const out = { ...DASHBOARD_DEFAULTS, ...(v || {}) };
  out.layout = out.layout === 'classic' ? 'classic' : 'priority';
  return out;
}

/** ダッシュボードの表示設定（人ごと）。[settings, update, stored] */
export default function useDashboardSettings() {
  return useUiSetting('dashboard', DASHBOARD_DEFAULTS, normalizeDashboardSettings);
}
